import React, { useRef, useLayoutEffect } from 'react';
import gsap from 'gsap';
import "./Contact.css";
import aboutImg from "../../Assets/about-me.jpg"
import { RxGithubLogo } from "react-icons/rx";
import Mylogo from '../../Assets/homeLogo.png';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SiMaterialdesignicons } from 'react-icons/si';
import { LiaConnectdevelop } from 'react-icons/lia';
import { GiAchievement } from 'react-icons/gi';

gsap.registerPlugin(ScrollTrigger);

const Contact = () => {


    const firstRef = useRef();
    const value1Ref = useRef();
    const value2Ref = useRef();
    const value3Ref = useRef();
    const value4Ref = useRef();
    const aboutenterRef = useRef();
    const aboutContRef = useRef();
    const aboutendRef = useRef();
    const secondRef = useRef();
    const wrapperRef = useRef();

    useLayoutEffect(() => {
        const ctx = gsap.context((self) => {
            const sections = self.selector("section");
            const stopPanelH = sections.findIndex((section) => section.dataset.pin1);
            const stopPanel = sections.findIndex((section) => section.dataset.pin);
            const stopPanel2 = sections.findIndex((section) => section.dataset.pin2);

            const tl = gsap.timeline({
                defaults: {
                    ease: "power1.inOut"
                },
                scrollTrigger: {
                    trigger: wrapperRef.current,
                    pin: true,
                    scrub: 2,
                    snap: 0.4 / (sections.length - 0.7),
                    end: () => "+=" + (wrapperRef.current.offsetWidth * (sections.length - 1))
                }
            });

            tl.to(sections, {
                xPercent: -(100 * stopPanelH),
                duration: stopPanelH
            })
            tl.to(aboutenterRef.current, {
                duration: 1,
                delay: 0.5,
                translateY: 1500
            })
            tl.to(sections, {
                xPercent: -(100 * stopPanel),
                duration: stopPanel
            })
            tl.to(firstRef.current, {
                duration: 3,
                delay: 3,
                rotateZ: -100,
                translateY: -1000
            })
            tl.to(value1Ref.current, {
                duration: 1,
                delay: 1,
                rotateZ: 100,
                translateY: 1000
            })
            tl.to(value2Ref.current, {
                duration: 1,
                rotateZ: 100,

                translateY: 1500
            })
            tl.to(value3Ref.current, {
                duration: 1,
                rotateZ: 100,

                translateY: 1500
            })
            tl.to(value4Ref.current, {
                duration: 1,
                rotateZ: 100,
                translateY: 1500
            })

            tl.to(aboutContRef.current, {
                duration: 1,
                opacity: 0,
                translateX: -250
            })
            tl.to(aboutendRef.current, {
                duration: 1,
                scale: 30,
                translateY: 40
            })
            tl.to(sections, {
                xPercent: -(100 * stopPanel2),
                duration: stopPanel2
            })
            tl.to(secondRef.current, {
                scale: 1.5,
                duration: 2
            })
            tl.to(sections, {
                xPercent: -(100 * (sections.length - 1)),
                duration: sections.length - stopPanel2
            });
        }, wrapperRef);

        return () => ctx.revert();
    }, []);

    return (
        <>
            <div className="wrappercont" ref={wrapperRef}>
                <section className="headercont" data-pin1="true">
                    <div className='aboutE' style={{ width: "100vw", height: "100vh" }} >
                        <img ref={aboutenterRef} src={Mylogo} alt="my-logo" />
                    </div>
                </section>
                <section className="firstcont" data-pin="true">
                    <div className='about' id='about__me'>
                        <div className='about-container'>
                            <div className='about-me' ref={firstRef}>
                                <div className='about-img' >
                                    <img src={aboutImg} alt="" />
                                </div>
                            </div>
                            <div className='aboutend' ref={aboutendRef} ><RxGithubLogo /></div>
                            <div className='about-content' ref={aboutContRef}>
                                <div className='about-values' >
                                    <div className='value' ref={value1Ref}>
                                        <SiMaterialdesignicons />
                                        <h4>Designer</h4>
                                        <p>Print Media Design,
                                            UI/UX Design</p>
                                    </div>
                                    <div className='value' ref={value2Ref}>
                                        <LiaConnectdevelop />
                                        <h4>Developmer</h4>
                                        <p>Front-end web development services</p>
                                    </div>
                                    <div className='value' ref={value3Ref}>
                                        <GiAchievement />
                                        <h4>Experience</h4>
                                        <p>2+ Years Working</p>
                                    </div>
                                </div>
                                <div className='about-desc' ref={value4Ref}>
                                    <h6>
                                        As a front-end developer, I have extensive experience with React.js.
                                        <br />
                                        I excel in self-management and collaboration, delivering high-quality, scalable web solutions.
                                        <br />
                                        Passionate about seamless user experiences,
                                        I focus on innovation and excellence.
                                        My track record includes developing interactive websites and complex web applications.

                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="secondcont" data-pin2="true">
                    <div className='aboutC' style={{ width: "100vw", height: "100vh" }} >
                        <h2 ref={secondRef}>Wondering About The Skills I Have ?</h2>
                    </div>
                </section>
            </div>
        </>
    );
}

export default Contact;
